import { createVNode as _createVNode } from "vue";
/**
 * @author yili
 * @fileoverview 赛事说明-PC
 */
import { defineComponent } from "vue";
// components
// 赛事规则
import RaceRules from "@/components/pc/race-rules.vue";
// 赛事奖励
import RaceAwards from "@/components/pc/race-awards.vue";
export default defineComponent({
  name: "RaceInfoPC",
  setup() {
    return () => {
      return _createVNode("div", {
        "class": "pc-explain",
        "id": "content-id"
      }, [_createVNode(RaceRules, null, null), _createVNode(RaceAwards, null, null)]);
    };
  }
});